// @ vendors
const get = require('lodash/object/get');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');
const reduce = require('lodash/collection/reduce');
const trim = require('lodash/string/trim');

// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;
const apiURLBuilder = require('core/apiURLBuilder');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const brokerConvenienceMifidTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');
const errorActions = require('actions/brokerError');
const { updateConsents } = require('actions/gdprConsents');

// @ constants
const {
    BROKER_CONVENIENCE_MIFID_TEST_EXTERNAL_TRANSFER_FUND,
    BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_PARTICIPATION,
    MYPROFILE_BROKER_TRANSFER_EXTERNAL_FUND_URL,
    MYPROFILE_BROKER_URL,
    BROKER_PRODUCT_TYPE_FUNDS_ES,
    EURO_TEXT,
    CHARGE_ACCOUNT_PREFIX,
    BROKER_ORDER_TYPE_BUY,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_MIFID_VERSION_2,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
} = require('constants/index');
const actionTypes = require('constants/actionTypes');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const { EXTERNAL_TRANSFER_FUND_POST_CONFIRMATION_ERROR } = require('constants/contactCenter/externalTransferFundActionErrorTypes');
const contactCenterActionTypes = require('constants/contactCenter/actionTypes');

const setVisibleStep = step => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillLeave = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_WILL_LEAVE
});

//TODO: Add a confirmation when a user click con Cancel.
const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const reset = () => (dispatch, getState) => {
    const immExternalTransferFund = getState().externalTransferFund
    if(!immExternalTransferFund.getIn(['steps', SECOND_STEP, 'currentlyOnMifid'])){
        dispatch({
            type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_RESET
        })
    }
};

const resetAmountDirty = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_RESET_AMOUNT_DIRTY
});

const validateStep = step => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_VALIDATE_STEP,
    payload: {
        step
    }
});

const setHasNif = (mustHasNif) => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_HAS_NIF,
    payload: {
        mustHasNif
    }
});

const showHelp = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SHOW_HELP
});

const hideHelp = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_HIDE_HELP
});

const setInstitutionName = institutionName => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_INSTITUTION_NAME,
    payload: {
        institutionName
    }
});
const setAccount = account => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_ACCOUNT,
    payload: {
        account
    }
});
const setNif = nif => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_NIF,
    payload: {
        nif
    }
});

const setOriginFund = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_FUND,
});

const selectOriginFund = product => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SELECT_FUND,
    payload: {
        value: product
    }
});

const resetOriginFund = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_RESET_FUND,
})

const setDestinationFund = (fundId, linkedToRobo) => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_DESTINATION_FUND,
    payload: {
        fundId,
        linkedToRobo,
    }
});

const setType = type => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_TYPE,
    payload: {
        type
    }
});

const setSubtype = subType => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_SUBTYPE,
    payload: {
        subType
    }
});

const setLegalInformationConf = (value) => ({
    type: contactCenterActionTypes.BROKER_LEGAL_INFORMATION_CONF_EXTERNAL_FUND,
    payload: {
        value
    }
});

const resetLegalInformation = () => ({
    type: contactCenterActionTypes.BROKER_LEGAL_INFORMATION_CONF_EXTERNAL_FUND_RESET
});

const setAmount = amount => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_AMOUNT,
    payload: {
        amount
    }
});

const setCheckbox = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_SET_CHECKBOX
});

const externalTransferFundFailure = (error, errorType = '') => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_FAILURE,
    payload: {
        error,
        errorType
    }
});

const getOriginFundInProgress = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_GET_ORIGIN_FUND_IN_PROGRESS
});

const getOriginFundSuccess = data => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_GET_ORIGIN_FUND_SUCCESS,
    payload: {
        data
    }
});

const getOriginFund = isin => dispatch => {
    const requestData = {
        query: {
            isinBuscador: isin,
            fondOrigen: 'S'
        }
    };
    dispatch(getOriginFundInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('traspasoExternoFondoOrigen'), requestData)
        .then(response => dispatch(getOriginFundSuccess(response)))
        .catch(response => dispatch(externalTransferFundFailure(response.error)));
};

const getIntervenersInProgress = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_GET_INTERVENERS_IN_PROGRESS
});

const getIntervenersSuccess = data => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_GET_INTERVENERS_SUCCESS,
    payload: {
        data
    }
});

const postValidationInProgress = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_POST_VALIDATION_IN_PROGRESS
});

const postValidationSuccess = data => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_POST_VALIDATION_SUCCESS,
    payload: {
        data
    }
});

function storeDocumentRequest() {
    return {
        type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_DOCUMENT_REQUEST
    };
}

function storeDocumentSuccess() {
    return {
        type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_DOCUMENT_SUCCESS
    };
}

function storeDocumentError() {
    return {
        type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_DOCUMENT_ERROR
    };

}

const postValidation = (dispatch, getState, history) => {
    const immExternalTransferFund = getState().externalTransferFund;
    const amount = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'amount']);
    const account = immExternalTransferFund.getIn(['steps', FIRST_STEP, 'account']);
    const codfon = immExternalTransferFund.getIn(['codfon']);
    const type = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'type']);
    const subType = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'subType']);
    const type1 = (type === 'P' && subType === BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_PARTICIPATION) ? 'P' : 'I';
    const nifGestora = immExternalTransferFund.getIn(['steps', FIRST_STEP, 'hasNif']) ? immExternalTransferFund.getIn(['steps', FIRST_STEP, 'nif']) :
    immExternalTransferFund.getIn(['originFund', 'nifGestora']);
    const isin = immExternalTransferFund.getIn(['originFund', 'isin']);
    const divisa = immExternalTransferFund.getIn(['originFund', 'currency']);

    let postData = {
        query: {
            codfon: codfon,
            codigoDocumento: nifGestora,

            codisin1: isin,
            codmons8: divisa,
            contde35: account,

            tipmo: type,
            tipo1: type1,
            tipoPersona: 'J'
        }
    };

    if (type === 'P') {
        if (type1 === 'P') {    //parcial transfer by participation
            postData.query.impmov = 0;
            postData.query.icsparti = amount;
        }
        else {                  //parcial transfer by amount
            postData.query.impmov = amount;
            postData.query.icsparti = 0;
        }

    }
    else {                      //total transfer
        postData.query.impmov = 0;
        postData.query.icsparti = 0;
    }

    dispatch(postValidationInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('traspasoExternoValidacion'), postData)
        .then(response => dispatch(postValidationSuccess(response)))
        .catch(response => {
                if (response.error) {
                    const errorKey = get(response, ["body", "error"], "");
                    dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
                    dispatch(externalTransferFundFailure(response.error));
                } else {
                    throw response;
                }
            });
}

const checkPostValidation = (history) => (dispatch, getState) => {
    postValidation(dispatch, getState, history);
}

const getSelectedDestinationFund = (immFunds, selectedDestinationFund) => {
    return immFunds.find(immFund => immFund.get('id') == selectedDestinationFund);
}

const getInterveners = (history, destinationFund = null) => (dispatch, getState) => {
    const selectedDestinationFund = destinationFund ?
        destinationFund :
        getState().externalTransferFund.getIn(['steps', THIRD_STEP, 'destinationFund']);
    const immFunds = getState().brokerMyInvestments.getIn(['products','funds','stocks']);
    const immFund = getSelectedDestinationFund(immFunds, selectedDestinationFund);
    const product = immFund.getIn(['product']);
    const type = immFund.getIn(['subtype']);
    const contractNumber = immFund.getIn(['numerodecontrato']);

    const requestData = {
        query: {
            pais: 'ES',
            referencia: '0000001',
            productoFondo: product,
            subtipoFondo: type,
            contratoFondoSeleccionado: contractNumber,
            productoFondoSeleccionado: product,
            empresaFondo: '0073'
        }
    };
    dispatch(getIntervenersInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('traspasoExternoIntervinientes'), requestData)
        .then(response => {
            dispatch(getIntervenersSuccess(response));
            if (destinationFund == null) {
                postValidation(dispatch, getState, history);
            }
        }).catch(response => {
            const errorKey = get(response, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
            dispatch(externalTransferFundFailure(response.error));
        })
}

const postConfirmationInProgress = () => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_POST_CONFIRMATION_IN_PROGRESS
});

const postConfirmationSuccess = data => ({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_POST_CONFIRMATION_SUCCESS,
    payload: {
        data
    }
});

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map(immDisclaimer => immDisclaimer.get('description')).join(' | ');
};

const getAccountOwningFundFromFundId = (immAccounts, immPurchasedFunds, fundId) => {
    if (immAccounts && immPurchasedFunds && fundId) {
        const immFundFromFundId = immPurchasedFunds.find(
            (immFund) => immFund.get('id') === fundId
        );

        if (immFundFromFundId) {
            const fundAssociatedAccount =
                immFundFromFundId.get('associatedAccountContractNumber');
            return immAccounts.find(
                (immAccount) => immAccount.get('contractNumber') === fundAssociatedAccount
            );
        }
    }
};

const storeDocuments = (orderResponse) => (dispatch, getState) => {
    let communicationServiceInput, data;
    const immProfile = getState().profile;
    const immExternalTransferFund = getState().externalTransferFund;
    const immBrokerMyInvestments = getState().brokerMyInvestments;

    const holder = getState().brokerStocksContract.getIn([0, 'walletTitular']);

    const destinationFundId = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'destinationFund']);
    const funds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
    const selectedDestinationFund = funds.find(x => x.get('id') === destinationFundId);

    const fundControlDigit = trim(selectedDestinationFund.get('controlDigit'));
    const fundContractNumber = trim(selectedDestinationFund.get('numerodecontrato'));
    const fundProductNumber = trim(selectedDestinationFund.get('product'));
    const fundIsin = selectedDestinationFund.get('isin');
    const fundCcv = trim(
        CHARGE_ACCOUNT_PREFIX +
        fundControlDigit +
        fundProductNumber +
        fundContractNumber
    );

    const immAccountOwningFund = getAccountOwningFundFromFundId(
        getState().accounts.get('byId'),
        funds,
        destinationFundId
    );
    const associatedAccountControlDigit =
        immAccountOwningFund ?
        trim(immAccountOwningFund.getIn(['ibanComplex', 'digitodecontrol'])) :
        '';
    const associatedAccountProduct =
        immAccountOwningFund ?
        trim(immAccountOwningFund.get('product')) :
        '';
    const associatedAccountContract =
        immAccountOwningFund ?
        trim(immAccountOwningFund.get('contractNumber')) :
        '';
    const associatedAccount = trim(
        CHARGE_ACCOUNT_PREFIX +
        associatedAccountControlDigit +
        associatedAccountProduct +
        associatedAccountContract
    );

    const amount = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'amount']);
    const emittedDateTime = momentTz(parseInt(get(orderResponse, 'timestamp', ''), 10)).tz("Europe/Madrid");

    const immBrokerFundLegalDocument =  getState().brokerFundLegalDocument;
    const productKidDocumentUrl = immBrokerFundLegalDocument.get('fundamentalDataForInvesorUrl');
    const marketingReportUrl = immBrokerFundLegalDocument.get('marketingReportsUrl');
    const economicReportUrl = immBrokerFundLegalDocument.get('lastPublishedEconomicReportUrl');

    const immFundTransactionCostDocument = immBrokerFundLegalDocument.getIn(['fundTransactionCostDocument', fundIsin]);
    const costYieldObjectId = immFundTransactionCostDocument ? immFundTransactionCostDocument.get('objectId') : '';

    communicationServiceInput = {
        "email":PersonalDataHelper.getEmail(immProfile),
        "productKID": productKidDocumentUrl,
        "contract": "",
        "marketingReport": marketingReportUrl,
        "economicReport": economicReportUrl,
        "infoCcv": "",
        "costYield": costYieldObjectId,
        "sendOrder": "No",
        "clientAlias": immProfile.get('nombreCliente'),
        "isin": fundIsin,
        "isinDescribe": selectedDestinationFund.get('name'),
        "idOrder": '',
        "channel" : CONNECTION_CHANNEL_INTERNET,
        "orderType" : BROKER_ORDER_TYPE_BUY,
        "productType" : BROKER_PRODUCT_TYPE_FUNDS_ES,
        "holders" : "" + [holder] ,
        "ccv" : fundCcv,
        "idContract": fundCcv,
        "ccc": associatedAccount,
        "market": "",
        "sharesNumber": "",
        "orderCondition": "",
        "sharesAmount": "" + amount,
        "termValidity" : "",
        "conditionPrize" : "",
        "currency": EURO_TEXT,
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime" : emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };

    data = {
        query: communicationServiceInput,
    };

    dispatch(storeDocumentRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), data).then(
        function () {
            dispatch(storeDocumentSuccess());
        },
        function () {
            dispatch(storeDocumentError());
        }
    );
}

const mifidDisclaimersResponse = (immBrokerConvenienceMiFIDTest) => {
    const isUsingMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
    let disclaimers = undefined;

    if (isUsingMifidv2) {
        const mifidv2AllDisclaimers =
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers'])
            .merge(immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']))
            .toJS();

        disclaimers = reduce(mifidv2AllDisclaimers, (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer_${index + 1}`;
            const disclaimerText = trim(get(disclaimer, 'description'));

            result[disclaimerKey] = `${trim(get(disclaimer, 'id'))} | ${disclaimerText}`;

            return result;
        }, {});
    }

    return disclaimers;
};

const postConfirmation = (dispatch, getState, dataToken, history) => {
    const immExternalTransferFund = getState().externalTransferFund;
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');
    const immAllFunds = getState().brokerMyInvestments.getIn(['products','funds','stocks']);
    const selectedDestinationFundId = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'destinationFund']);
    const immDestinationFund = getSelectedDestinationFund(immAllFunds, selectedDestinationFundId);
    const product = immDestinationFund.getIn(['product']);
    const contractNumber = immDestinationFund.getIn(['numerodecontrato']);
    const amount = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'amount']);
    const account = immExternalTransferFund.getIn(['steps', FIRST_STEP, 'account']);
    const codfon = immExternalTransferFund.getIn(['codfon']);
    const interveners = immExternalTransferFund
        .getIn(['interveners', 'byId'])
        .toIndexedSeq()
        .toArray();
    const divisa = immDestinationFund.getIn(['totalValueCurrency']);
    const type = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'type']);
    const subType = immExternalTransferFund.getIn(['steps', THIRD_STEP, 'subType']);
    const isin = immExternalTransferFund.getIn(['originFund', 'isin']);
    const codigodepersona = immExternalTransferFund.getIn(['validation', 'codigodepersona']);
    const type1 = (type === 'P' && subType === BROKER_TRANSFER_EXTERNAL_FUND_PARTIAL_PARTICIPATION) ? 'P' : 'I';

    const selectedDestinationFundIsin = immDestinationFund.getIn(['isin']);
    const shares = type === 'P' ? amount : immDestinationFund.get('shares');
    const fundManager = immExternalTransferFund.getIn(['steps', FIRST_STEP, 'institution']);

    const icsalcon = immExternalTransferFund.getIn(['validation', 'icsalcon']);
    const icsaldis = immExternalTransferFund.getIn(['validation', 'icsaldis']);

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');

    let postData = {
        header: {
            'version': 2
        },
        query:{
            codfon: codfon,
            codisin1: isin,
            codmons8: divisa,
            codperggestoraDestino: codigodepersona,
            contde35: account,
            contratoFondo: {
                numerodecontrato: contractNumber,
                producto: product
            },
            icsalcon,
            icsaldis,
            intervinientes: {
                dato: interveners
            },
            tipmo: type,
            tipo1: type1,
            tipoperggestoraDestino: 'J',
            dataToken,
            "convenienceTest": "",
            "currency": EURO_TEXT,
            "destinationIsin": selectedDestinationFundIsin,
            "initQuantity": shares,
            "productIsin": selectedDestinationFundIsin,
            "productManager":  fundManager,
            "tipoUnidadTraspaso":"K",
            "agentId": 100,
            "micCode": "",
            "convenientRegistry": immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
            "evaluateRegistry": mifidWasApplied,
            "disclaimers": mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
            "marketTargetRegistry": mifidScore >= mifidScoring,
            "necessaryConvenienceTestNote": mifidScoring,
            "necessaryTargetMarketNote": immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
            "testConveniencyResult": mifidScore,
            "documentationId": uuid
        }
    };

    if (type === 'P') {
        if (type1 === 'P') {    //parcial transfer by participation
            postData.query.impmov = 0;
            postData.query.icsparti = amount;
        }
        else {                  //parcial transfer by amount
            postData.query.impmov = amount;
            postData.query.icsparti = 0;
        }

    }
    else {
        postData.query.impmov = 0;
        postData.query.icsparti = 0;
    }

    dispatch(postConfirmationInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('traspasoExternoConfirmacion'), postData)
        .then(response => {
            dispatch(postConfirmationSuccess(response));
            dispatch(storeDocuments(response));
        })
        .catch(response => {
            if (response.error) {
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
                dispatch(externalTransferFundFailure(response.error, __CONTACT_CENTER__ && EXTERNAL_TRANSFER_FUND_POST_CONFIRMATION_ERROR));
                throw response;
            }
        });
};

const confirmationTransfer = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(updateConsents(dataToken))
            .then(() => postConfirmation(dispatch, getState, dataToken, history))
            .catch(() => postConfirmation(dispatch, getState, dataToken, history));
    };
    const isAlreadyFetching = getState().externalTransferFund.get('isFetchingConfirmation');

    if (!isAlreadyFetching) {
        new Promise(function() {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

const startMifid = (history) => (dispatch, getState) => {
    const destinationFundName = '';
    const destinationFundUrl = '';
    const destinationFundProductId = undefined;
    const urlContinueOperation = MYPROFILE_BROKER_TRANSFER_EXTERNAL_FUND_URL;
    const operationData = {
        operationType: BROKER_CONVENIENCE_MIFID_TEST_EXTERNAL_TRANSFER_FUND,
        externalTransferFundState: getState().externalTransferFund.toJS(),
        breadcrumb: [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerExternalTransferFund'),
                url: MYPROFILE_BROKER_TRANSFER_EXTERNAL_FUND_URL
            }
        ]
    };

    dispatch(brokerConvenienceMifidTestActions.start(
        history,
        destinationFundName,
        destinationFundUrl,
        destinationFundProductId,
        urlContinueOperation,
        operationData
    ));
};


const cancelMifid = (externalTransferFundStateBeforeMifid, history) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_CANCEL_MIFID,
        payload: { externalTransferFundStateBeforeMifid }
    });

    history.replace(MYPROFILE_BROKER_TRANSFER_EXTERNAL_FUND_URL);
};

const continueFromMifid = (externalTransferFundStateBeforeMifid, history) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_CONTINUE_FROM_MIFID,
        payload: { externalTransferFundStateBeforeMifid }
    });

    history.replace(MYPROFILE_BROKER_TRANSFER_EXTERNAL_FUND_URL);
};

const setDocumentsRead = () => (dispatch) => dispatch({
    type: actionTypes.BROKER_WIZARD_EXTERNAL_TRANSFER_FUND_DOCUMENTS_READ
});

module.exports = {
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    setInstitutionName,
    reset,
    setLegalInformationConf,
    resetLegalInformation,
    validateStep,
    confirmationTransfer,
    showHelp,
    hideHelp,
    resetOriginFund,
    selectOriginFund,
    setAccount,
    setNif,
    setOriginFund,
    setDestinationFund,
    setType,
    setSubtype,
    setAmount,
    setCheckbox,
    getOriginFund,
    getInterveners,
    checkPostValidation,
    postValidation,
    resetAmountDirty,
    startMifid,
    cancelMifid,
    continueFromMifid,
    setDocumentsRead,
    setHasNif,
};
